export const RANGE_OPTIONS = [
  {
    label: '+10 Km',
    value: 10
  },
  {
    label: '+15 Km',
    value: 15
  }, {
    label: '+20 Km',
    value: 20
  },
  {
    label: '+25 Km',
    value: 25
  },
  {
    label: '+50 Km',
    value: 50
  },
  {
    label: '+75 Km',
    value: 75
  },
  {
    label: '+100 Km',
    value: 100
  },
  {
    label: '+150 Km',
    value: 150
  },
  {
    label: '+200 Km',
    value: 200
  }
]
